import moment from 'moment';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useAppContext } from '../../appProvider/contextProvider';
import Calendars from '../../components/Calendars/Calendars';
import Graph from '../../components/Graph/Graph';
import Loader from '../../components/Loader/loader';
import { getSubscribersGrowth } from '../../services/subscribersService';

export const SubscriberGrowth = () => {
    const { selectedWebsite } = useAppContext();
    const [isFilterOpen , setIsFilterOpen] = useState(false);

    const [subscribersFilter, setSubscribersFilter] = useState({
        name: 'Last 7 Days',
        startDay: moment().subtract(7, 'days').startOf('day'),
        endDay: moment(),
    });

    const [subscriptionGrowthData, setSubscriptionGrowthData] = useState([]);

    
    useQuery(['fetchSubsGrowth', {
            webId: selectedWebsite?.id,
            dates: {
                start_date: moment(subscribersFilter.startDay).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                end_date: moment(subscribersFilter.endDay).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            }
        }],  () => getSubscribersGrowth({
            webId: selectedWebsite?.id,
            dates: {
                start_date: moment(subscribersFilter.startDay).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                end_date: moment(subscribersFilter.endDay).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            }
        }), {
        enabled: !!selectedWebsite,
        onSuccess: ((growths) => {
            setSubscriptionGrowthData(growths);
        })
    });

    const getCustomRange = () => {
        return `${moment(subscribersFilter.startDay).format('DD/MM/YYYY')} - ${moment(subscribersFilter.endDay).format('DD/MM/YYYY')}`;
    }

    return <>
    <div className="card full-width p-4">
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <h6 className="">Subscriber Growth</h6>
                        <div className="d-flex flex-wrap align-items-center">
                            <div className="form-group  date-form-group mb-0">
                                <div className="input-addon input-group-right" onClick={() => setIsFilterOpen(!isFilterOpen)} >
                                    <i className="icon icon-calendar"></i>
                                    <input
                                        value={subscribersFilter.name !== 'Custom Dates' ? subscribersFilter.name : getCustomRange() }
                                        placeholder="This Week" 
                                        className="form-control"
                                    />
                                </div>
                                {
                                    isFilterOpen && <Calendars
                                        subscribersFilter={subscribersFilter}
                                        setSubscribersFilter={setSubscribersFilter}
                                        setIsFilterOpen={setIsFilterOpen}
                                    />
                                }
                            </div>
                            {/* <p className="round-indicator mb-2 ml-2">Subscriber Growth</p> */}
                        </div>                                    
                    </div> 
                    <Graph subscribersFilter={subscribersFilter.name} subscriptionGrowthData={subscriptionGrowthData} />
                                                
                    <p className="text-center mt-4 mb-2 text-grey">The data displayed in the above graph is not real-time, so there may be a delay in updates.</p>                             
                </div>                            

    </>
}



export const SubscriberLoader = () => {
    console.log('I am called');
    return <div className="card full-width p-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
                <h6 className="">Subscriber Growth</h6>                                
            </div>
            <div style={{height: '300px', maxHeight: '300px', position: 'relative'}}>     
                <Loader />
            </div>
    </div>
}